<template>
  <div class="tw:flex tw:items-center tw:text-white tw:text-base">
    <input
      v-model="search"
      type="text"
      :placeholder="placeholder ?? $t('coreSearch')"
      class="tw:outline-none tw:w-full tw:h-7 tw:leading-none"
    />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  placeholder?: string;
}>();

const search = defineModel<string>({ required: true });
</script>
